<!--
 * @Author: 金小瑞
 * @Date: 2019-07-18 16:01:59
 * @LastEditors: 金小瑞
 * @LastEditTime: 2019-09-05 15:09:38
 * @Description: '新建 工单特殊字段'
 -->
<!-- 
  新建 工单特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
  emit: 
    showProduct: 打开关联商品弹窗
    change: 模板更新
 -->

<template>
  <div class="customer">
    <!-- 工单模板 -->
    <template v-if="item.attr === 'tempalteSelect'">
      <el-select v-model="form[item.attr]" @change="handleTemp" :disabled="item.nonEditable===1" placeholder="请选择">
        <el-option
          v-for="arr in item.valueArrMap"
          :key="arr.key"
          :label="arr.value"
          :value="arr.key">
        </el-option>
      </el-select>
    </template>
    <!-- 负责人 -->
    <template v-else-if="item.attr === 'mainUser'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 客户 -->
    <template v-else-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        @emitObj="changeCustomer"
        >
      </associated-field>      
    </template>
    <!-- 联系人 -->
    <template v-else-if="item.attr === 'contact'">
      <remote-select
        v-if="form.customerName"
        module="contact"
        :customerId="form.customerName.id"
        :always="true"
        :item="item"
        :form="form">
      </remote-select>
      <span v-else>无</span>
    </template>
    <!-- 关联机会 -->
    <template v-else-if="item.attr === 'opportunity'">
      <remote-select
        v-if="form.customerName"
        module="opportunity"
        moduleName='workOrder'
        :customerId="form.customerName.id"
        :always="true"
        :item="item"
        :form="form">
      </remote-select>
      <span v-else>无</span>
    </template>
    <!-- 关联合同 -->
    <template v-else-if="item.attr === 'contract'">
      <el-input
        v-if="item.nonEditable===1"
        :disabled="true"
        :value="item.attrValue.value || '无'">
      </el-input>
      <remote-select
        v-else-if="form.customerName.id"
        module='contract'
        :customerId="form.customerName.id"
        :always="true"
        :item="item"
        :form="form">
      </remote-select>
      <span v-else>无</span>
    </template>
    <!-- 联系方式 -->
    <v-phone
      v-else-if="item.attr === 'phone'"
      @numChange="phoneSave"
      :attrValue.sync="form.phone">
    </v-phone>
    <!-- 实施备件 -->
    <template v-else-if="item.attr === 'products'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template>
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      ref="address"
      v-else-if="item.attr === 'address'"
      :attrValue="form.address">
    </v-address>
    <!-- 实施时间 -->
    <template v-else-if="item.attr === 'implementingTime'">
      <el-date-picker
        :class="{disable: item && item.nonEditable}"
        v-model="form[item.attr]"
        :editable="false"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        placeholder="选择实施时间">
      </el-date-picker>
    </template>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapGetters, mapActions } from 'vuex'
import vManager from '../manager'
import associatedField from '../associated-field'
import remoteSelect from '../remote-select'
import vAddress from '../address'
import vPhone from '../phone'

export default {
  props: ['item', 'form'],
  data () {
    return {
      Products: this.form.products
    }
  },
  computed: {
    ...mapGetters([
      'getUpdateAddress'
    ])
  },
  methods: {
    ...mapActions([
      'setAttr',
      'setUpdateAddress'
    ]),

    // 监听选择框的变化
    handleTemp (value) {
      this.$emit('change', value, 'temp')
    },

    addressSave (arr) {
      if (this.item.required && !arr.address.trim()) {
        this.$set(this.form, 'address', '')
      } else {
        this.$set(this.form, 'address', arr)
      }
      this.setAttr('address')
    },
    phoneSave (arr) {
      this.$set(this.form, 'phone', arr)
    },
    emitParent () {
      let type = 'add'
      if (this.Products.length) {
        type = 'edit'
      }
      this.$emit('showProduct', type)
    },
    // 重置关联单据
    changeCustomer (obj) {
      this.form.contactName = ''
      this.form.opportunity = ''
      this.form.contact = ''
      if (obj) {
        this.getPhoneAddress(obj.id)
      }
    },

    // 获取客户的地址和电话
    getPhoneAddress (id) {
      const url = '/customerApi/getPhoneAddress.html'
      let params = {
        id: id
      }
      api.post(url, params, (data) => {
        this.form.address = data.result.address
        this.form.phone = data.result.phone

        // 手动更新地址组件
        this.setUpdateAddress()
      })
    },

    // 监听实施时间的变化
    // handleDatetimeChange (datetime) {
    //   this.$set(this.form, 'implementingTime', datetime)
    // },

    addNew (arr) {
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num = utils.plus(num, item.num)
      })
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    vManager,
    remoteSelect,
    associatedField,
    vAddress,
    vPhone
  },

  watch: {
    // 手动更新address组件的数据
    getUpdateAddress () {
      if (this.$refs.address) {
        if (this.form.address && !this.form.address.province && !this.form.address.address) {
          this.form.address = ''
        }
        this.$refs.address.initAddress(this.form.address)
        this.setAttr('address')
      }
    },

    // 产品
    form: {
      handler () {
        if (this.form.products) {
          this.Products = this.form.products
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/fieldtype-products.less";
</style>


// WEBPACK FOOTER //
// index.vue?edad1d5c